<script>
    // boolean whether the init state should be checked
    export let isChecked = false
    // boolean whether the init state should be disabled
    export let isDisabled = false
    // string containing the message for when disabled
    export let disabledCallbackText = false;
    // boolean whether the toggle should be dark mode or not
    export let darkMode = false
    // function to be executed on toggle
    export let callback = () => {}
    // label: string containg the label(s) for this toggle
    export let label = ''

    // boolean for wether the label(s) is/are static or statefull.
    // example stateful: "ON/OFF"
    // example static: "Turn feature X on"
    $: labelStateful = typeof label === 'object';

    function onChange() {
        if (isDisabled) {
            if (disabledCallbackText) {
                Backbone.View.layout.openStatus(disabledCallbackText, 'warning')
            }
            return
        }

        setState(!isChecked)
    }

    export function toggleState(silent = false) {
        setState(!isChecked, silent)
    }

    export function setState(checked, silent = false) {
        isChecked = checked

        if (silent) {
            return
        }

        if (callback) {
            callback(isChecked);
        }
    }
</script>

<button
    class="toggle"
    class:toggle--active={isChecked}
    class:toggle--darkmode={darkMode}
    role="switch"
    aria-checked={isChecked}
    on:click|stopPropagation={onChange}
>
    <div class="box">
        <div class="knob"></div>
    </div>

    <div class="label--state">
        {isChecked ? window.i18n.gettext('On').toUpperCase() : window.i18n.gettext('Off').toUpperCase()}
    </div>

    {#if labelStateful}
        <div class="label">
            {isChecked ? label.on : label.off}
        </div>
    {/if}

    {#if !labelStateful && label}
        <div class="label">{label}</div>
    {/if}

</button>

<style lang="scss">/*
* Scut, a collection of Sass utilities
* to ease and improve our implementations of common style-code patterns.
* v1.0.1
* Docs at http://davidtheclark.github.io/scut
*/
/* TODO implement tooltip arrow */
.toggle {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.toggle--active .box {
  background: hsl(205, 60%, 44%);
}
.toggle--active .knob {
  margin-left: 18px;
}
.toggle--active .label--state {
  color: hsl(205, 60%, 44%);
}
.toggle--active:hover .box {
  background: hsl(205, 58%, 38%);
}
.toggle--active:hover .knob {
  margin-left: 16px;
}
.toggle:not(.toggle--active):hover .box {
  background: #9a9bb5;
}
.toggle:not(.toggle--active):hover .knob {
  margin-left: 2px;
}
.toggle--darkmode .label {
  color: #fff;
}
.toggle--darkmode .label--state {
  color: #fff;
}
.toggle--darkmode .box {
  background: rgba(255, 255, 255, 0.35) !important;
}
.toggle--darkmode.toggle--active .box {
  background: #3fd17d !important;
}

.box {
  display: flex;
  align-items: center;
  height: 24px;
  width: 42px;
  border: 2px solid transparent;
  border-radius: 24px;
  background: rgba(154, 155, 181, 0.75);
  transition: background 0.35s cubic-bezier(0.455, 0.03, 0.515, 0.955);
}

.knob {
  width: 20px;
  height: 20px;
  margin-left: 0;
  border-radius: 20px;
  background: #fff;
  transition: margin-left 0.35s cubic-bezier(0.455, 0.03, 0.515, 0.955);
}

.label {
  font-size: 14px;
  user-select: none;
  margin-left: 8px;
  color: rgba(18, 45, 64, 0.8);
}
.label:empty {
  display: none;
}
.label--state {
  transition: color 0.35s cubic-bezier(0.455, 0.03, 0.515, 0.955);
  min-width: 30px;
  margin-left: 8px;
}</style>
